import React from "react"
import { useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { MAX_LENGTH_DESCRIPTION_TEXT } from "shared/constants/app-constants"
import { MarkdownInput } from "shared/ui/input/markdown/MarkdownInput"
import {
  HeadingLevel,
  MarkdownEditorProps
} from "shared/ui/input/markdown/components/MarkdownEditor"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"

const allowedHeadingLevels: HeadingLevel[] = [2]

const textareaProps: MarkdownEditorProps["textareaProps"] = {
  "data-testid": "product-position-form__remark__input"
} as MarkdownEditorProps["textareaProps"]

export const ProductPositionRemarkInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoading } = useProductPositionFormLoadingContext()
  const { hideRemark, isRemarkReadonly } = formOptions || {}

  const remark = useWatch({ name: "productPosition.remark" })

  if (hideRemark || (!remark && isReadonly)) return null

  return (
    <MarkdownInput.Root
      name="productPosition.remark"
      label={t("General.Remark")}
      maxLength={MAX_LENGTH_DESCRIPTION_TEXT}
      readonly={isReadonly || isRemarkReadonly}
      loading={isLoading}
      disabled={isDisabled}
      className="product-position-form__remark"
      data-testid="product-position-form__remark"
    >
      <MarkdownInput.Container maxHeight={null}>
        <MarkdownInput.Input
          allowedHeadingLevels={allowedHeadingLevels}
          textareaProps={textareaProps}
        />
        <MarkdownInput.Readonly />
        <MarkdownInput.Counter />
      </MarkdownInput.Container>
      <MarkdownInput.ErrorMessage />
    </MarkdownInput.Root>
  )
})
